module.exports = __webpack_public_path__ + "media/site/images/logos/logo-rubylogic-dbeda5280462ab867c39f637d1ec25c6.svg";